export default __webpack_public_path__ + "static/media/hilary.fec9f202.JPG";